import {
  AnalyticsItemCategory,
  AnalyticsItemVariant,
} from "../analytics.types";
import {
  AnalyticsItemReturnData,
  gaEventViewItemList,
} from "../common.analytics";
import { gaPushEvent } from "../base.analytics";

enum Event {
  JOURNAL_FOLLOW = "journal_follow",
  JOURNAL_UNFOLLOW = "journal_unfollow",
}

type AnalyticsJournal = { id: string; name: string };

type JournalItemPayload = {
  journal: AnalyticsJournal;
  listName: string;
};

type JournalItemListPayload = {
  journals: AnalyticsJournal[];
  listName: string;
};

function convertJournalToItemData(
  payload: JournalItemPayload
): AnalyticsItemReturnData {
  const { journal, listName } = payload;
  return {
    item_id: journal.id,
    item_name: journal.name,
    item_brand: journal.name, // NOTE: Journals are a brand themselves.
    item_category: null, // NOTE: Journals don't have specialties.
    item_category2: AnalyticsItemCategory.STANDARD,
    item_variant: AnalyticsItemVariant.JOURNALS,
    item_list_name: listName,
  };
}

export function gaEventViewItemListJournal(payload: JournalItemListPayload) {
  gaEventViewItemList(
    payload.journals.map((journal) => {
      return convertJournalToItemData({
        journal,
        listName: payload.listName,
      });
    })
  );
}

export function gaEventJournalFollow(journalName: string) {
  gaPushEvent(Event.JOURNAL_FOLLOW, { journal: journalName });
}

export function gaEventJournalUnfollow(journalName: string) {
  gaPushEvent(Event.JOURNAL_UNFOLLOW, { journal: journalName });
}
